import React from 'react';
import * as THREE from "three";
import '../applications-css/Application.css'
import "../applications-css/Screensavers.css";

class Screensavers extends React.Component {
  constructor(props) {
    super(props);
    let width = this.props.width;
    let height = this.props.height;
    this.state = {
      currentSize: {
        width: this.props.width,
        height: this.props.height,
      },
      renderer: new THREE.WebGLRenderer(),
      camera: new THREE.PerspectiveCamera(75, width / height, 0.1, 1000),
    };
  }

  componentDidMount() {
    // handle initial setup
    let width = this.refs.screensaverZone.offsetWidth;
    let height = this.refs.screensaverZone.offsetHeight;
    var camera = this.state.camera;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    var renderer = this.state.renderer;
    renderer.setSize(width, height);
    this.refs.screensaverZone.appendChild(renderer.domElement);
    this.renderedScene2();
  }

  componentDidUpdate() {
    //update renderer if needed
    let width = this.refs.screensaverZone.offsetWidth;
    let height = this.refs.screensaverZone.offsetHeight;
    var renderer = this.state.renderer;
    var camera = this.state.camera;
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
    renderer.setSize(width, height);
  }

  renderedScene1() {
    var scene = new THREE.Scene();
    var renderer = this.state.renderer;
    var camera = this.state.camera;
    var geometry = new THREE.BoxGeometry(1, 1, 1);
    var material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
    var cube = new THREE.Mesh(geometry, material);
    scene.add(cube);
    camera.position.z = 5;
    var animate = function() {
      requestAnimationFrame(animate);
      cube.rotation.x += 0.01;
      cube.rotation.y += 0.01;
      renderer.render(scene, camera);
    }
    animate();
  }

  renderedScene2() {
    let orbiterRadius = 0.25;

    var scene = new THREE.Scene();
    var renderer = this.state.renderer;
    var camera = this.state.camera;

    scene.rotation.z = 90;

    var group = new THREE.Object3D();
    scene.add(group);

    var center = new THREE.Object3D();
    group.add(center);

    var sunGeometry = new THREE.SphereGeometry(1, 32, 32);
    var earthGeometry = new THREE.SphereGeometry(orbiterRadius, 32, 32);
    var orbiterMaterial = new THREE.MeshBasicMaterial( {color: 0xffffff} );
    var orbiter1Material = new THREE.MeshBasicMaterial( {color: 0x696969} );

    var sun = new THREE.Mesh(sunGeometry, orbiterMaterial);
    sun.position.y = 0;
    scene.add(sun);

    var earth = new THREE.Mesh(earthGeometry, orbiter1Material);
    earth.position.y = 2;
    center.add(earth);

    camera.position.z = 5;
    var animate = function() {
      requestAnimationFrame(animate);
      group.rotation.x += 0.01;
      // center.rotation.z += 0.01;
      renderer.render(scene, camera);
    }
    animate();
  }

  render() {
    return(
      <div className="outsideWrapper" ref="screensaverZone">
      </div>
    )
  }
}

export default Screensavers;
